import React from "react";
import { Button } from "@/components/ui/Button";
import { XIcon } from "lucide-react";

export interface FilterPillProps {
  label: string;
  onRemove: () => void;
  removeAriaLabel?: string;
  className?: string;
}

export const FilterPill: React.FC<FilterPillProps> = ({
  label,
  onRemove,
  removeAriaLabel,
  className = "",
}) => {
  return (
    <Button
      variant="outline"
      className={`w-40 p-1.75 ${className}`}
      data-testid="filter-pill"
    >
      <span data-testid="filter-pill-label">{label}</span>
      <Button
        asChild
        variant="ghost"
        onClick={onRemove}
        aria-label={removeAriaLabel}
        data-testid="filter-pill-remove"
      >
        <div className="flex h-4 w-4 cursor-pointer items-center justify-center rounded-full p-0.5 hover:bg-transparent">
          <XIcon className="text-muted-foreground" />
        </div>
      </Button>
    </Button>
  );
};
